import * as React from 'react';
import { themr } from 'react-css-themr';
import { confirmationDialogFactory } from 'common/components/core/dialog/ConfirmationDialog';
import compose from 'recompose/compose';
import { translate } from 'react-i18next';

import theme from './MapBulkVerifyConfirmationDialog.scss';
import { dashboardColors } from 'common/enums/ColorEnum';

export const ConfirmationDialog = confirmationDialogFactory({});

class MapBulkDeleteDialog extends React.PureComponent {
    render() {
        const { count, onCancel, onAccept, theme, active, t } = this.props;

        return (
            <ConfirmationDialog
                title={t('zoneMap.deleteFolder')}
                innerText={t('zoneMap.deleteFolderWarning', { count })}
                theme={theme}
                onAccept={onAccept}
                className={theme.bulkDeleteDialog}
                onCancel={onCancel}
                acceptActionLabel={t('zoneMap.delete')}
                acceptActionColor={dashboardColors.salmon.name}
                active={active}
            />
        );
    }
}

const ThemedMapBulkDeleteDialog = compose(
    themr('VerifyConfirmationDialog', theme),
    translate('entityManagement')
)(MapBulkDeleteDialog);
export { ThemedMapBulkDeleteDialog as MapBulkDeleteDialog };
export default ThemedMapBulkDeleteDialog;
